// Section Type related constants

import { SectionTypeStatus } from '../types/sectionType';

/**
 * 货架类型状态颜色映射
 */
export const SECTION_TYPE_STATUS_COLORS = {
  [SectionTypeStatus.DRAFT]: 'default',
  [SectionTypeStatus.ENABLE]: 'success',
  [SectionTypeStatus.DISABLE]: 'warning',
} as const;

/**
 * 货架类型状态标签映射
 */
export const SECTION_TYPE_STATUS_LABELS = {
  [SectionTypeStatus.DRAFT]: '草稿',
  [SectionTypeStatus.ENABLE]: '启用',
  [SectionTypeStatus.DISABLE]: '停用',
} as const;


/**
 * 状态选项
 */
export const SECTION_TYPE_STATUS_OPTIONS = [
  { label: 'common.all', value: 'all' },
  { label: 'sectionType.statusTest.DRAFT', value: SectionTypeStatus.DRAFT },
  { label: 'sectionType.statusTest.ENABLE', value: SectionTypeStatus.ENABLE },
  { label: 'sectionType.statusTest.DISABLE', value: SectionTypeStatus.DISABLE },
] as const;

